module.exports = {
    tag: 'garland',
    quality: 1.0,
    magicDamageMod: 0.05
}